import "./BadgeComponent.scss";
import {Badge} from "@mui/material";

interface BadgeComponentProps {
    badgeContent: React.ReactNode;
    color?: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
    children?: React.ReactNode;
}

const BadgeComponent = (props: BadgeComponentProps) => {
    const {badgeContent, color = 'primary', children} = props;

    return (
        <Badge badgeContent={badgeContent} color={color}
               className={'badge-component'}
               anchorOrigin={{
                   vertical: 'top',
                   horizontal: 'right',
               }}
        >
            {children}
        </Badge>
    );

};

export default BadgeComponent;
